import ButtonComponent from '../Button/Button.mjs';
import styled from 'styled-components';

const StyledWrapper = styled.div `
  width: 100%;

  @media screen and (min-width: ${props => props.theme.breakpoints.md}) {
    max-width: 502px;
  }
`;
const StyledInput = styled.input `
  width: 100%;
  box-sizing: border-box;
  color: ${props => props.theme.colors.white};
  background-color: transparent;
  font-size: ${props => props.theme.typography.text.tiny.fontSize};
  font-weight: ${props => props.theme.typography.fontWeight.regular};
  text-shadow: 0 0 0.6px ${props => props.theme.colors.white},
    0 0 0.6px ${props => props.theme.colors.white};
  border-radius: 4px 0 0 4px;
  border: 1px solid ${props => props.theme.colors.white};
  border-right: none;
  padding: 1.5rem calc(1rem + 2px) 0.3rem 1rem;
  outline: none;
  transition: box-shadow ${props => props.theme.animation.duration.quick1}
    ${props => props.theme.animation.easing.productive.standard};

  @media screen and (max-width: ${props => props.theme.breakpoints.md}) {
    padding-top: 21px;
    padding-bottom: 6px;
  }
`;
const StyledSubmitButton = styled(ButtonComponent) `
  position: relative;
  padding: 0.75rem 23px;
  left: -2px;
  font-size: ${props => props.theme.typography.text.small.fontSize};
  color: ${props => props.theme.colors.midnightBlue};
  background-color: ${props => props.theme.colors.white};
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;

  @media screen and (max-width: ${props => props.theme.breakpoints.md}) {
    padding: 12px 23px 10px;
  }
`;
const StyledPlaceholder = styled.span `
  position: absolute;
  color: ${props => props.theme.colors.white};
  font-size: ${props => props.theme.typography.text.tiny.fontSize};
  top: 1rem;
  left: 1rem;
  transition: all ${props => props.theme.animation.duration.quick1}
    ${props => props.theme.animation.easing.productive.standard};
  transform-origin: 0 0;
  background: none;
  pointer-events: none;

  @media screen and (max-width: ${props => props.theme.breakpoints.md}) {
    top: 15px;
    left: 17px;
  }
`;
const StyledInputWithButton = styled.form `
  display: grid;
  grid-template-rows: repeat(2, max-content);
  grid-template-columns: 1fr max-content;
  position: relative;

  ${StyledInput} {
    &:focus {
      box-shadow: 0 0 0 1px ${props => props.theme.colors.white} inset;
      text-shadow: none;
    }

    &:focus + ${StyledPlaceholder}, &:valid + ${StyledPlaceholder} {
      transform: scale(0.8) translateY(-0.7rem);
    }

    &:not(:focus) + ${StyledPlaceholder} {
      opacity: 80%;
    }

    &:disabled,
    &:disabled + ${StyledPlaceholder} {
      opacity: 30%;
    }
  }
`;

export { StyledInput, StyledInputWithButton, StyledPlaceholder, StyledSubmitButton, StyledWrapper };
//# sourceMappingURL=InputWithButton.styles.mjs.map
